export const cilFilter = ["24 24","<path d='M11.186 23.25h-2.186v-11.352l-7.875-9.375v-1.773h21.375v1.763l-7.5 9.375v7.548zM10.5 21.75h0.064l2.936-2.936v-7.452l7.29-9.112h-17.935l7.646 9.102z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-filter.js
// module id = null
// module chunks = 